import { MenuItem, MenuObject } from "src/types/auth/auth";

const CLOUDFLARE_URL = (import.meta as any).env?.VITE_CLOUD_FLARE_URL || "https://sassydev.cloud";

export const cdnUrl = (key?: string | null): string => {
  if (!key) return "";
  if (/^https?:\/\//i.test(key)) return key;
  if (key.startsWith("blob:") || key.startsWith("data:")) return key;
  const base = CLOUDFLARE_URL.replace(/\/$/, "");
  return `${base}/${key.replace(/^\//, "")}`;
};

export const convertPermissionToObject = (menuArray: MenuItem[]): MenuObject => {
  const result: MenuObject = {};
  console.log({ menuArray })
  menuArray.forEach((menu) => {
    if (menu.menuCode) {
      result[menu.menuCode] = {
        menuName: menu.menuName,
        isEdit: menu.isEdit,
        isView: menu.isView
      };
    }
  });

  return result;
};
export const generateUrl = (path: string): string => cdnUrl(path);

export const formatDateTime = (value?: string | Date | null): string => {
  if (!value) return "-";
  const date = new Date(value);
  if (isNaN(date.getTime())) return "-";
  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};